<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M18.1001 8.33342H3.1001M13.9334 1.66675V5.00008M7.26676 1.66675V5.00008M7.1001 18.3334H14.1001C15.5002 18.3334 16.2003 18.3334 16.7351 18.0609C17.2055 17.8212 17.5879 17.4388 17.8276 16.9684C18.1001 16.4336 18.1001 15.7335 18.1001 14.3334V7.33342C18.1001 5.93328 18.1001 5.23322 17.8276 4.69844C17.5879 4.22803 17.2055 3.84558 16.7351 3.6059C16.2003 3.33341 15.5002 3.33341 14.1001 3.33341H7.1001C5.69997 3.33341 4.9999 3.33341 4.46512 3.6059C3.99472 3.84558 3.61226 4.22803 3.37258 4.69844C3.1001 5.23322 3.1001 5.93328 3.1001 7.33341V14.3334C3.1001 15.7335 3.1001 16.4336 3.37258 16.9684C3.61226 17.4388 3.99472 17.8212 4.46512 18.0609C4.9999 18.3334 5.69997 18.3334 7.1001 18.3334Z"
      stroke="#414651"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon",
};
</script>
